import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import "./MailPage.scss";
import { useNavigate } from "react-router-dom";

const MailPage = () => {
  const [mails, setMails] = useState([
    {
      id: 1,
      subject: "Welcome!",
      content: "Thanks for signing up.",
      from: "admin@kcmit.com",
      isRead: true,
    },
    {
      id: 2,
      subject: "Meeting Reminder",
      content: "Don’t forget our meeting tomorrow.",
      from: "admin@kcmit.com",
      isRead: true,
    },
  ]);

  const [selectedMail, setSelectedMail] = useState(null);
  const [newMail, setNewMail] = useState({ to: "", subject: "", content: "" });
  const [replyContent, setReplyContent] = useState("");
  const [showNewMailForm, setShowNewMailForm] = useState(true);
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleDelete = (id) => {
    setMails(mails.filter((mail) => mail.id !== id));
    setSelectedMail(null);
  };

  const handleReply = () => {
    if (selectedMail && replyContent.trim()) {
      const reply = {
        id: Date.now(),
        subject: "Re: " + selectedMail.subject,
        content: replyContent,
        from: "me@mail.com",
        isRead: true,
      };
      setMails([reply, ...mails]);
      setReplyContent("");
    }
  };

  const handleSend = () => {
    const mail = {
      id: Date.now(),
      ...newMail,
      from: "me@mail.com",
      isRead: true,
    };
    setMails([mail, ...mails]);
    setNewMail({ to: "", subject: "", content: "" });
    setShowNewMailForm(false);
  };

  return (
    <div className="mailPage">
      <div className="mailSidebar">
        <div className="mailHeader">
          <FaArrowLeft className="backArrow" onClick={handleBackClick} />
          <h2>Mail Box</h2>
        </div>

        <button
          className="createMailButton"
          onClick={() => {
            setShowNewMailForm(true);
            setSelectedMail(null);
          }}
        >
          Create New Mail
        </button>

        <div className="mailList">
          <h3>Inbox</h3>
          {mails.map((mail) => (
            <div
              key={mail.id}
              className={`mailItem ${mail.isRead ? "read" : "unread"} ${
                selectedMail?.id === mail.id ? "isActive" : ""
              }`}
              onClick={() => {
                setSelectedMail(mail);
                setShowNewMailForm(false);
              }}
            >
              <h4>{mail.subject}</h4>
              <p>From: {mail.from}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mailContent">
        {showNewMailForm ? (
          <div className="newMailForm">
            <h3>New Mail</h3>
            <input
              type="email"
              placeholder="To"
              value={newMail.to}
              onChange={(e) => setNewMail({ ...newMail, to: e.target.value })}
            />
            <input
              type="text"
              placeholder="Subject"
              value={newMail.subject}
              onChange={(e) =>
                setNewMail({ ...newMail, subject: e.target.value })
              }
            />
            <textarea
              placeholder="Message"
              value={newMail.content}
              onChange={(e) =>
                setNewMail({ ...newMail, content: e.target.value })
              }
            />
            <button onClick={handleSend}>Send</button>
          </div>
        ) : selectedMail ? (
          <div className="mailDetail">
            <h2>{selectedMail.subject}</h2>
            <p>{selectedMail.content}</p>
            <textarea
              placeholder="Write a reply..."
              value={replyContent}
              onChange={(e) => setReplyContent(e.target.value)}
            />
            <div className="actionButtons">
              <button onClick={() => handleDelete(selectedMail.id)}>
                Delete
              </button>
              <button onClick={handleReply}>Send Reply</button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MailPage;
